module.exports = __webpack_public_path__ + "img/FR16606.3b7cac1d.png";